import React, { useRef } from 'react'
import './committeebios.css';

import aditi from './images/Leadership/2025-2026/committees/aditi.jpg';
import ahana from './images/Leadership/2025-2026/committees/ahana.jpg';
import christina from './images/Leadership/2025-2026/committees/christina.jpg';
import dana from './images/Leadership/2025-2026/committees/dana.jpg';
import iris from './images/Leadership/2025-2026/committees/iris.jpg';
import ishita from './images/Leadership/2025-2026/committees/ishita.jpg';
import kandyce from './images/Leadership/2025-2026/committees/kandyce.jpg';
import priyanka from './images/Leadership/2025-2026/committees/priyanka.jpg';
import raika from './images/Leadership/2025-2026/committees/raika.jpg';
import samyuktha from './images/Leadership/2025-2026/committees/samyuktha.jpg';
import stephanie from './images/Leadership/2025-2026/committees/stephanie.jpg';
import sushmita from './images/Leadership/2025-2026/committees/sushmita.jpg';
import vasudha from './images/Leadership/2025-2026/committees/vasudha.jpg';

import {BsFacebook, BsDiscord} from 'react-icons/bs'
import {RiInstagramFill} from 'react-icons/ri'

const Combio = () => {
  const ref = useRef(null);
  
  const committees = [
    {
      name: 'Social Media Committee',
      description: 'The WiC Social Media Committee manages WiC\'s social media platforms, including the WiC website, Instagram, Facebook, and Discord server. They also take photos during WiC events and create social media graphics and posters for WiC events. See more of the WiC Social Media Committee\'s work on our various social media accounts and platforms!',
      members: [
        { name: 'Kandyce Diep', image: kandyce },
        { name: 'Priyanka Mungra', image: priyanka }
      ]
    },
    {
      name: 'Public Relations Committee',
      description: 'The WiC Public Relations Committee is in charge of planning career events, which aim to offer engaging and unique career development opportunities to WiC members. Events from the 2023-24 school year include the Winter Affiliates Dinner, Uber Technical Interview Workshop, Women in Tech Panel with Pinterest, and Preparing for the Summer with The Trade Desk.',
      members: [
        { name: 'Dana Khasanov', image: dana },
        { name: 'Raika Roy Choudhury', image: raika },
        { name: 'Sushmita Musunuri', image: sushmita }
      ]
    },
    {
      name: 'Social Events Committee',
      description: 'As a team, the Social Events committee focuses on organizing engaging and enjoyable Member Meetings for the WiC community at the Allen school every quarter. These events have included self-care nights, craft nights, and trivia nights, among others. Collaborating closely with the rest of the executive team, we carefully select dates, scout venues, and design activities to foster a strong sense of community and bring everyone closer together.',
      members: [
        { name: 'Aditi Dewangan', image: aditi },
        { name: 'Ahana Mangla', image: ahana },
        { name: 'Ishita Bansal', image: ishita }
      ]
    },
    {
      name: 'Outreach Committee',
      description: 'The WiC Outreach Committee organizes events and workshops for middle and high schoolers that introduce them to computer science and technology. In the past, they organized the Launch Your Future outreach event which focused on the intersection of Computer Science and Entrepreneurship. Also, they hosted a startup founder panel, DubHacks Next panel, and a HTML workshop.',
      members: [
        { name: 'Christina Pham', image: christina },
        { name: 'Iris Litiu', image: iris },
        { name: 'Samyuktha Krishnan', image: samyuktha },
        { name: 'Stephanie Kha', image: stephanie },
        { name: 'Vasudha Ravivarma', image: vasudha }
      ]
    }
  ];

  return (
    <>
      <div>
        <div>
          <br></br>
          <br></br>
          <div className='teamTitle-wrapper'>
            <p id="teamTitle">Committees 2025 - 2026</p>
          </div>
        </div>
        <div className="committees-container">
          {committees.map((committee, idx) => (
            <div key={idx} className="committee-section">
              <div className="committee-left">
                <h3 className="committee-name">{committee.name}</h3>
                <p className="committee-description">{committee.description}</p>
              </div>
              <div className="committee-right">
                <div className="members-grid">
                  {committee.members.map((member, midx) => (
                    <div key={midx} className="member-card">
                      <div className="img-background">
                        <img className="memberImage" src={member.image} alt={member.name} />
                      </div>
                      <div className="teamInfo">
                        <h4 className="teamName"><b>{member.name}</b></h4>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='actions' ref={ref}>
        <div className='action-description'>
          <p><strong>Not a WiC member?</strong></p>
          <p>Join <a href='http://tinyurl.com/wic-membership-form' target='_blank' rel="noreferrer" className='footerLink'>here</a> and sign up for our <a href='https://mailman.cs.washington.edu/mailman/listinfo/wic' target='_blank' rel="noreferrer" className='footerLink'>mailing list</a> to get updates on events and opportunities! Follow us on our Facebook and Instagram page! Join our Discord server!</p>
        </div>
        <br></br>
        <div className='socials'>
          <a id='insta' href='https://www.instagram.com/uw.wic/' aria-label="Instagram" target='_blank' rel="noreferrer"><RiInstagramFill/></a>
          <a id='fbook' href='https://www.facebook.com/uwwic' aria-label="Facebook" target='_blank' rel="noreferrer"><BsFacebook/></a>
          <a id='discord' href='https://discord.gg/Zp4GVB7ddq' aria-label="Discord" target='_blank' rel="noreferrer"><BsDiscord/></a>
        </div>
        <div className='wicEmail'>
          <a href="mailto:wic-officers@cs.washington.edu" className='footerLink'>wic-officers@cs.washington.edu</a>
        </div>
      </div>
    </>
  )
}

export default Combio;
